import { render, staticRenderFns } from "./FormularioGrupoComponent.vue?vue&type=template&id=a85a5efe"
import script from "./FormularioGrupoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioGrupoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports